/* eslint-env browser */
/* global adobe */
import riot from 'riot'
import riotRoute from 'riot-route'
import logger from './logger'
import { ApplicationObservableInstance } from './observables/application-observable'
import routesDef from './routes-def'
import routeStates from './route-states'

// updateProgress
// model
// calculateInitialRoute
// hasBlockingOrderIssues
// orderModel


let firstPageLoad = true

export default (() => (function routerIIFE() {
  const loginHotSwap = (route) => {
    const checkoutLogin = document.getElementById('in-progress-order')
    const doneLogin = document.getElementById('finished-order')

    if (doneLogin && checkoutLogin) {
      if (routesDef.orderConfirmation === route) {
        doneLogin.classList.remove('hidden')
        checkoutLogin.classList.add('hidden')
      } else {
        doneLogin.classList.add('hidden')
        checkoutLogin.classList.remove('hidden')
      }
    }
  }

  const triggerView = (viewName) => {
    if (typeof adobe !== 'undefined' && adobe.target && typeof adobe.target.triggerView === 'function') {
      // Strip all / and . from the route when sending to adobe
      adobe.target.triggerView(viewName.replace(/\.|\//g, ''))
    }
  }

  const targetSelector = 'content-view'
  const init = () => {
    // Start listening to route changes
    riotRoute.stop()

    riotRoute(routesDef.base, () => {
      logger(`ROUTE :: ${routesDef.base}`, 'info')()
      const queryRoute = riotRoute.query().route
      ApplicationObservableInstance.updateProgress(routeStates.base)

      function doFirstRoute(route) {
        riotRoute(route, null, firstPageLoad)
        firstPageLoad = false
      }

      ApplicationObservableInstance.model.willBootstrap = true

      if (queryRoute) {
        doFirstRoute(queryRoute)
      } else {
        ApplicationObservableInstance.calculateInitialRoute()
          .then(doFirstRoute)
          .catch((error) => {
            logger(error, 'error')()
            riotRoute(routesDef.membership, null, firstPageLoad)
          })
      }
    })

    riotRoute('/transition', () => {
      logger(`ROUTE :: ${routesDef.membership}`, 'info')()
      riot.mount(targetSelector, 'transition-page')
    })

    riotRoute(routesDef.membership, () => {
      triggerView(routesDef.membership)
      logger(`ROUTE :: ${routesDef.membership}`, 'info')()
      ApplicationObservableInstance.updateProgress(routeStates.membership)
      loginHotSwap(routesDef.membership)
      riot.mount(targetSelector, 'membership-page')
    })

    riotRoute(routesDef.contactBilling, () => {
      triggerView(routesDef.contactBilling)
      logger(`ROUTE :: ${routesDef.contactBilling}`, 'info')()
      ApplicationObservableInstance.updateProgress(routeStates.contactBilling)
      loginHotSwap(routesDef.contactBilling)
      riot.mount(targetSelector, 'contact-billing-page')
    })

    riotRoute(routesDef.shippingOptions, () => {
      triggerView(routesDef.shippingOptions)
      logger(`ROUTE :: ${routesDef.shippingOptions}`, 'info')()
      loginHotSwap(routesDef.shippingOptions)
      riot.mount(targetSelector, 'shipping-options-page')
    })

    riotRoute('/shipping-options/*', (state) => {
      triggerView(routesDef.shippingOptions)
      logger(`ROUTE :: ${routesDef.shippingOptions}`, 'info')()
      loginHotSwap(routesDef.shippingOptions)
      riot.mount(targetSelector, 'shipping-options-page', { state })
    })

    riotRoute(routesDef.storePickup, () => {
      triggerView(routesDef.storePickup)
      logger(`ROUTE :: ${routesDef.storePickup}`, 'info')()
      loginHotSwap(routesDef.storePickup)
      riot.mount(targetSelector, 'store-pickup-page')
    })

    riotRoute(routesDef.orderSummary, () => {
      const alternateRoute = ApplicationObservableInstance.hasBlockingOrderIssues()

      // If there are no line items route the user to the cart or if the order has been submitted
      if (!ApplicationObservableInstance.orderModel.lineItems.length || ApplicationObservableInstance.orderModel.orderStatus.state === 'SUBMITTED') {
        window.location.href = '/ShoppingCart'
      } else if (alternateRoute && alternateRoute !== routesDef.orderSummary) {
        riotRoute(alternateRoute)
      } else {
        triggerView(routesDef.orderSummary)
        logger(`ROUTE :: ${routesDef.orderSummary}`, 'info')()
        ApplicationObservableInstance.updateProgress(routeStates.orderSummary)
        loginHotSwap(routesDef.orderSummary)
        riot.mount(targetSelector, 'order-review-page')
      }
    })

    riotRoute(routesDef.orderConfirmation, () => {
      const q = riotRoute.query()

      logger(`ROUTE :: ${routesDef.orderConfirmation}`, 'info')()
      loginHotSwap(routesDef.orderConfirmation)
      if (q.ref === 'ap') {
        riot.mount(targetSelector, 'order-confirmation-page', { isApplePay: true })
      } else {
        riot.mount(targetSelector, 'order-confirmation-page')
      }
    })

    // unknown route bucket.
    riotRoute((...args) => {
      const badRoute = args.join('/')
      logger(`BAD ROUTE :: ${badRoute}`, 'warning')()
      ApplicationObservableInstance.calculateInitialRoute()
        .then((route) => {
          riotRoute(route, null, true) // redirect them to where they should be.
        })
        .catch((error) => {
          logger(error, 'error')()
          riotRoute(routesDef.membership, null, true)
        })
    })

    riotRoute.start(true)
  }

  return {
    init,
  }
}())
)()
